import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const groupSectionEntityName = 'groupSection';
export const groupSectionColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { title: {
        type: 'string-required',
    }, displayOrder: {
        type: 'number',
    }, description: {
        type: 'string',
    }, key: {
        type: 'string',
    }, search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
